import { mutate } from 'swr';
// logic
import { useHistory } from 'react-router-dom';
import ticketService from 'modules/emergencies/ticketService';
// components
import { CancelTicketModal } from './cancelTicketModal';
import { Modal } from 'react-async-popup';
import '../ui/emergencyPopup.css';

const useCancelTicketModal = (ticket) => {
  const history = useHistory();
  const cancelTicketModalProps = { ticket };
  const cancelTicket = async () => {
    const { show } = await Modal.new({
      content: <CancelTicketModal cancelTicketModalProps={cancelTicketModalProps} />,
      footer: null,
    });
    const result = await show();
    return result;
  };

  const openModalCancelTicket = async () => {
    const result = await cancelTicket();
    if (result) {
      const feedBackDTO = {
        reasons: [
          {
            category: result.reason,
          },
        ],
      };
      if (result.text.trim().length > 0) feedBackDTO.text = result.text;
      await ticketService.callBackend.cancelTicket({ id: ticket.id, feedBackDTO });
      // we are mutating the tickets cache so it will reload automatically
      mutate((key) => {
        return typeof key === 'string' && key.startsWith('tickets');
      });
      ticketService.utils.navigateToList({ history });
    }
  };

  return {
    openModalCancelTicket,
  };
};

export default useCancelTicketModal;
